import { useSuspenseQuery } from '@tanstack/react-query'

import { promotionsConfigurationQuery } from './promotionsConfiguration'

export const usePromotionCampaign = (initiativeId: string) => {
  const { data: state } = useSuspenseQuery(promotionsConfigurationQuery())
  const configuration = state.data
  return configuration?._id === 'Promotions' ? configuration.campaigns?.[initiativeId] : undefined
}
